import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { AdminService } from './../services/admin.service';
import { ImpiantoService } from './../services/impianto.service';

import { Implant } from '../../app/models/implant';
import { Admin } from '../../app/models/admin';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';


declare var require: any;
const swal = require('sweetalert2');

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {

    public idUtente: any;
    public ruolo: string;
    public nuovaPassword: string;
    public confermaPassword: string;
    public vecchiaPassword: string;

    constructor(private dialogRef: MatDialogRef<ChangePasswordComponent>, private authService: AuthService, private adminService: AdminService, private impiantoService: ImpiantoService, private toastr: ToastrService, @Inject(MAT_DIALOG_DATA) private data: any, private route: ActivatedRoute, private router: Router) {
        this.idUtente = this.data.id;
        this.ruolo = this.data.ruolo;
    }

    back(): void {
        this.dialogRef.close();
    }

    //---Manage type of password changePassword---//

    public changePassword() {
        if (this.ruolo == null)
            this.changePasswordCurrentUser();

        if (this.ruolo == "2" || this.ruolo == "1")
            this.changePasswordAdmins();

        if (this.ruolo == "3")
            this.changePasswordImpant();

        if (this.ruolo == "4")
            this.changePasswordClient();

        if (this.ruolo == "5")
          this.changePasswordOperatore();
    }

    public changePasswordCurrentUser() {
        this.authService.putChangePasswordCurrentUser(this.vecchiaPassword, this.nuovaPassword, this.confermaPassword).subscribe(result => {
            this.dialogRef.close(this.data);
            this.toastr.success('', 'Password modificata.', {
                timeOut: 3000,
            });
        }, err => {
            swal("Errore!", err.error.message, "error");
        });
    }

    public changePasswordAdmins() {
        this.adminService.putModificaPasswordAdmin(this.idUtente, this.confermaPassword).subscribe(result => {
            this.dialogRef.close(this.data);
            this.toastr.success('', 'Password modificata.', {
                timeOut: 3000,
            });
        }, err => {
            swal("Errore!", err.error.message, "error");
        });
    }

    public changePasswordImpant() {
        this.adminService.putModificaPasswordImpianto(this.idUtente, this.confermaPassword).subscribe(result => {
            this.dialogRef.close(this.data);
            this.toastr.success('', 'Password modificata.', {
                timeOut: 3000,
            });
        }, err => {
            swal("Errore!", err.error.message, "error");
        });
    }

    public changePasswordClient() {
        this.adminService.putModificaPasswordCliente(this.idUtente, this.confermaPassword).subscribe(result => {
            this.dialogRef.close(this.data);
            this.toastr.success('', 'Password modificata.', {
                timeOut: 3000,
            });
        }, err => {
            swal("Errore!", err.error.message, "error");
        });
    }

    public changePasswordOperatore() {
      this.adminService.putModificaPasswordOperatore(this.idUtente, this.confermaPassword).subscribe(result => {
        this.dialogRef.close(this.data);
        this.toastr.success('', 'Password modificata.', {
          timeOut: 3000,
        });
      }, err => {
        swal("Errore!", err.error.message, "error");
      });
    }

    public changePasswordConditions() {
        if (this.data.ruolo == null)
            if (this.vecchiaPassword == null || this.vecchiaPassword == '')
                return true;
        if (this.nuovaPassword == null || this.nuovaPassword == '')
            return true;
        if (this.confermaPassword == null || this.confermaPassword == '')
            return true;
        if (this.nuovaPassword != this.confermaPassword)
            return true;

        return false;
    }

    changePasswordConditionsCurrentUser() {

        if (this.vecchiaPassword == null || this.vecchiaPassword == '')
            return true;
        if (this.nuovaPassword == null || this.nuovaPassword == '')
            return true;

        return false;
    }

    ngOnInit(): void {
    }
}



// WEBPACK FOOTER //
// ./src/app/change-password-component/change-password.component.ts